// src/pages/CrmCustomers/crmCustomersThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {saveAccountApi,deleteAccountApi} from "../../apiservice/accounts";
import {getCrmCustomerListApi} from "../../apiservice/crm";

export const fetchCrmCustomers = createAsyncThunk(
  "crmCustomers/fetchCrmCustomers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCrmCustomerListApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCrmCustomerGroups = createAsyncThunk(
  "crmCustomers/fetchCrmCustomerGroups",
  async (_, { rejectWithValue }) => {
    try {
      const res = {}
      // await getCrmCustomerGroupsApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCrmCustomerCode = createAsyncThunk(
  "crmCustomers/fetchCrmCustomerCode",
  async (_, { rejectWithValue }) => {
    try {
      const res ={}
      //  await getCrmCustomerCodeApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const saveCrmCustomer = createAsyncThunk(
  "crmCustomers/saveCrmCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveAccountApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteCrmCustomer = createAsyncThunk(
  "crmCustomers/deleteCrmCustomer",
  async (acc_id, { rejectWithValue }) => {
    try {
      const payload ={acc_id:acc_id}
      const res = await deleteAccountApi(payload); 
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

